import * as React from 'react';
import { getPalette } from 'owa-theme';

export interface StyledHoverElementProps {
    /**
     * If set to true background color of child element
     * will be highlightedColor and on hover it will be
     * highlightedHoverColor
     */
    isHighlighted?: boolean;

    // background color property for selected element
    highlightedColor?: string;

    // background color property for selected element on hover
    highlightedHoverColor?: string;

    // background color property for element on hover
    hoverColor?: string;

    //hover callback
    onHoverCallback?: (isHoverState: boolean) => void;
}

export interface StyledHoverElementState {
    isInHoverState: boolean;
}

/**
 * Wrapper to implement hover based on styles passed
 * ie. highlightedColor, highlightedHoverColor and hoverColor
 */
export default class StyledHoverElement extends React.Component<
    StyledHoverElementProps,
    StyledHoverElementState
> {
    public static defaultProps: StyledHoverElementProps = {
        isHighlighted: false,
    };

    constructor(props: StyledHoverElementProps) {
        super(props);
        this.state = {
            isInHoverState: false,
        };
    }

    private turnHoverOn = () => {
        this.setState({
            isInHoverState: true,
        });
        this.props.onHoverCallback && this.props.onHoverCallback(true);
    };

    private turnHoverOff = () => {
        this.setState({
            isInHoverState: false,
        });
        this.props.onHoverCallback && this.props.onHoverCallback(false);
    };

    render() {
        return (
            <div
                style={this.getStyleForElement()}
                onMouseEnter={this.turnHoverOn}
                onMouseLeave={this.turnHoverOff}>
                {this.props.children}
            </div>
        );
    }

    /**
     * Create style for row based on state ie. selected, hover etc.
     */
    private getStyleForElement(): React.CSSProperties {
        const { isInHoverState } = this.state;
        const themeSymbols = getPalette();
        const {
            highlightedColor = themeSymbols.themeLighter,
            highlightedHoverColor = themeSymbols.themeLight,
            hoverColor = themeSymbols.neutralLighter,
            isHighlighted,
        } = this.props;

        if (isInHoverState && isHighlighted) {
            return {
                backgroundColor: highlightedHoverColor,
                cursor: 'pointer',
            };
        } else if (isHighlighted) {
            return {
                backgroundColor: highlightedColor,
            };
        } else if (isInHoverState) {
            return {
                backgroundColor: hoverColor,
                cursor: 'pointer',
            };
        } else {
            return {};
        }
    }
}
